import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AccordionItem = ({
    heading,
    content,
    elementId,
    onHeaderClick,
    onItemClick,
    showText = true,
    noItemMessage = ""
}) => {
    const [show, setShow] = useState(true);
    const [data, setData] = useState([]);
    const [translate] = useTranslation();

    const { id, objectSubTypeId } = useParams();

    useEffect(() => {
        setData([...content]);
    }, [content, setData]);

    const handleHeaderClick = useCallback(
        (event) => {
            event.stopPropagation();
            event.preventDefault();
            onHeaderClick && onHeaderClick(elementId);
        },
        [elementId, onHeaderClick]
    );

    const handleItemClick = useCallback(
        (event, element) => {
            event.preventDefault();
            onItemClick(elementId, element._id);
        },
        [elementId, onItemClick]
    );

    const isHeadingActive = useMemo(() => {
        return elementId && id === elementId && !objectSubTypeId;
    }, [objectSubTypeId, id, elementId]);

    const getItemHighlightElementId = useMemo(() => {
        return onHeaderClick ? objectSubTypeId : id;
    }, [onHeaderClick, objectSubTypeId, id]);

    const renderListItems = useMemo(() => {
        return (
            data.length > 0 && data.map((element, index) => {
                if (element._id) {
                    return (
                        <button
                            className={`list-group-item list-group-item-action small ${element._id === getItemHighlightElementId ? "active" : ""}`}
                            data-element={element}
                            key={element._id}
                            onClick={(event) => handleItemClick(event, element)}
                        >{element.name}</button>
                    );
                }

                return (
                    <li className="list-group-item small" key={0}>{translate(noItemMessage)}</li>
                );
            })
        );
    }, [data, translate, noItemMessage, getItemHighlightElementId, handleItemClick]);

    return (
        <div className="accordion-item" key={elementId}>
            <h6 className="accordion-header">
                <button className={`accordion-button ${show ? "" : "collapsed"} ${isHeadingActive ? "active" : ""}`}
                    type="button"
                    onClick={() => setShow(!show)}
                >
                    <span onClick={(event) => { handleHeaderClick(event) }}>
                        {heading}
                    </span></button>
            </h6>
            <div className={`accordion-collapse collapse ${show ? "show" : ""}`} >
                <div className="accordion-body p-0">
                    <ul className="list-group list-group-flush">
                        {renderListItems}
                        {showText && data.length === 0 && (
                            <li className="list-group-item small" key={0}>{translate(noItemMessage)}</li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AccordionItem;
